/** Shared letterhead payload for formal DocSlip prints — plan/43. */

export type LetterheadPrint = {
  tradeName: string;
  legalName: string | null;
  addressLine1: string | null;
  addressLine2: string | null;
  city: string | null;
  province: string | null;
  postalCode: string | null;
  countryCode: string;
  tin: string | null;
  phone: string | null;
  email: string | null;
  website: string | null;
  registrationNote: string | null;
  permitNote: string | null;
  /** Same-origin logo URL when hasLogo; null → name-only header */
  logoUrl: string | null;
};

export function formatLetterheadAddress(lh: LetterheadPrint): string[] {
  const lines: string[] = [];
  if (lh.addressLine1) lines.push(lh.addressLine1);
  if (lh.addressLine2) lines.push(lh.addressLine2);
  const cityLine = [lh.city, lh.province, lh.postalCode]
    .filter(Boolean)
    .join(", ");
  if (cityLine) lines.push(cityLine);
  if (lh.countryCode && lh.countryCode !== "PH") lines.push(lh.countryCode);
  return lines;
}

export function formatLetterheadContacts(lh: LetterheadPrint): string[] {
  const bits: string[] = [];
  if (lh.tin) bits.push(`TIN ${lh.tin}`);
  if (lh.phone) bits.push(lh.phone);
  if (lh.email) bits.push(lh.email);
  if (lh.website) bits.push(lh.website);
  return bits;
}
